var _radialGradient, _linearGradient;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpressionsAverageWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 129,
    viewBox: "0 0 332 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y1yonpyola",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v2q08qkhcc",
    x1: 0.5,
    y1: 1.017,
    x2: 0.5,
    y2: -0.606,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ddb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6f8ff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "y0t3pyj86b"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2859",
    width: 332,
    height: 129,
    rx: 16,
    transform: "translate(-8523 -11790)",
    style: {
      fill: "url(#y1yonpyola)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Insight Card Inside Graphic",
    transform: "translate(8523 11790)",
    style: {
      clipPath: "url(#y0t3pyj86b)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2744"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2677"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2712",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v62.2H0v-62.2A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8213.887 -11730.645)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2713",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V49.9H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8213.887 -11710.903)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2714",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v34.781H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8233.741 -11703.226)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2715",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v19.426H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8233.741 -11687.871)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2679"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2716",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v75.91H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8253.59 -11744.354)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2717",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V54.29H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8253.59 -11715.29)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2680"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2718",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V83.9H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8273.444 -11744.903)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2719",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v56.716H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8273.444 -11725.161)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2681"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2720",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V102H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8293.297 -11763)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2721",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v62.748H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8293.297 -11731.194)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2682"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2722",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v60.006H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8313.149 -11728.451)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2723",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V51H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8313.149 -11711.999)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2683",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2724",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v35.329H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8333 -11703.773)",
    style: {
      opacity: 0.5,
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2725",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v22.716H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8333 -11691.16)",
    style: {
      fill: "url(#v2q08qkhcc)",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressionsAverageWeek);
export default __webpack_public_path__ + "static/media/impressions-average-week.fba8f37484e62398601fb59a0f02489c.svg";
export { ForwardRef as ReactComponent };